// IPC Global brand and footer values (portal workbench spec, 2026-09-29).
// Copied from www.ipc-global.com, not scraped: re-check them against the
// live site at each release (the site is maintained by
// Websiteteam@ipc-global.com). The tel: link dials +14704079100; the live
// site's own tel: link was wrong on 2026-09-29 and was reported separately.

function deepFreeze(value) {
  if (value && typeof value === 'object') {
    Object.values(value).forEach(deepFreeze);
    Object.freeze(value);
  }
  return value;
}

export const BRAND = deepFreeze({
  siteUrl: 'https://www.ipc-global.com',
  supportUrl: 'https://support.ipc-global.com',
  tagline: 'Transforming data into actionable insights through AI-powered analytics and visualization.',
  links: [
    { label: 'Our Products', href: 'https://www.ipc-global.com/products' },
    { label: 'Contact', href: 'https://www.ipc-global.com/contact-us' },
    { label: 'Get Support', href: 'https://support.ipc-global.com' },
  ],
  contact: {
    salesEmail: 'sales@ipc-global.com',
    supportEmail: 'support@ipc-global.com',
    phoneDisplay: '+1 (470) 407-9100',
    phoneHref: 'tel:+14704079100',
    phoneExtensions: 'ext 1 sales, ext 3 support',
  },
  legal: [
    { label: 'Privacy Policy', href: 'https://www.ipc-global.com/privacy-policy' },
    { label: 'Terms of Service', href: 'https://www.ipc-global.com/terms-services' },
    { label: 'Cookie Policy', href: 'https://www.ipc-global.com/cookies' },
  ],
  trademarkNotice: 'Qlik®, Qlik Sense®, QlikView®, Qlik Cloud®, Qlik Replicate®, Talend®, and Amazon Web Services® (AWS®) are trademarks of their respective owners. IPC Global is an authorized Qlik Elite and AWS Advanced partner.',
});

/** The footer copyright line. */
export function copyrightLine(year = new Date().getFullYear()) {
  return `© ${year} IPC Global. All rights reserved.`;
}

// The onGuard slogan and the About line (Confluence page 17271488558, onGuard Brand Reference, approved 2026-10-12). The slogan is
// exactly this text, with the period. The reports keep their own copy in report-lambda/render/brand.mjs (a separate bundle
// cannot import this module): change both together. The scripture reference belongs only in the About line, never in a footer, an email or a report.
export const SLOGAN = 'Be on guard.';
export const ABOUT_LINE = 'onGuard takes its name from a simple charge, "Be on guard" (Matthew 10:17). We build tools that help IT teams stay watchful over the systems they are trusted with.';
